require("ng-file-upload");
require('../shared/profileService');

'use strict';

angular.module('app.myProfile.myProfileService', [
  'ngFileUpload',
  'app.shared.profileService'
])
  .factory('app.myProfile.myProfileService', [
    '$http',
    'currentUser',
    'DEFAULT_PROFILE_IMAGE',
    'Upload',
    'app.shared.profileService',
    function ($http, currentUser, DEFAULT_PROFILE_IMAGE, Upload, profileService) {
      let profile;
      return profile = {
        data: null,
        process_data: function (data, notEditable) {
          if (data.user) {
            profile.data = data.user;
            if (!profile.data.profile_image) {
              profile.data.profile_image = DEFAULT_PROFILE_IMAGE;
            }
            profile.data.live_watched_count = parseInt(profile.data.live_watched_count);
            profile.data.archived_watched_count = parseInt(profile.data.archived_watched_count);
            profile.data.clips_count = parseInt(profile.data.clips_count);
            profile.data.is_profile_public = !!parseInt(profile.data.is_profile_public);
            profile.data.following = parseInt(profile.data.following);
            profile.data.followers = parseInt(profile.data.followers);
            profile.data.membership_date = momentToDate(moment(profile.data.membership_date));
            profile.data.notEditable = !!notEditable === true;
            profile.data.client_profile_url = profileService.buildProfileUrl(profile.data.username);
          }
        },
        retrieve: function (customIuserid) {

          let idToRetrieve = (customIuserid ? customIuserid : currentUser.data.iuserid);
          let notEditable = !!customIuserid;

          return $http.get(window.location.api('users/' + idToRetrieve + '/profile'))
            .then((response) => {
              let data = response.data;
              profile.process_data(data, notEditable);
              return response;
            });


        },
        /**
         * @param {string} field
         * @param {{firstName: string, lastName: string, city: string, state: string}} value
         */
        save: function (field, value) {
          let params = {};
          if (field) {
            switch (field) {
              case 'name':
                if (value && typeof value.firstName !== 'undefined') {
                  params.first_name = value.firstName;
                }
                else if (profile.data) {
                  params.first_name = profile.data.first_name;
                }

                if (value && typeof value.lastName !== 'undefined') {
                  params.last_name = value.lastName;
                }
                else if (profile.data) {
                  params.last_name = profile.data.last_name;
                }
                break;
              case 'address':
                if (value && typeof value.city !== 'undefined') {
                  params.city = value.city;
                }
                else if (profile.data) {
                  params.city = profile.data.city;
                }

                if (value && typeof value.state !== 'undefined') {
                  params.state = value.state;
                }
                else if (profile.data) {
                  params.state = profile.data.state;
                }
                break;
              case 'is_profile_public':
                if (typeof profile.data.username !== 'undefined') {
                  params.username = profile.data.username;
                }
                params[field] = profile.data[field];
                break;
              default:
                if (typeof value === 'undefined' && profile.data) {
                  params[field] = profile.data[field];
                }
                else {
                  params[field] = value;
                }
                break;
            }

            return $http.put(window.location.api('users/' + currentUser.data.iuserid + '/profile'), params)
              .then((response) => {
                let data = response.data;
                if (!response.data.error && (parseInt(response.status) === 200)) {
                  currentUser.update();
                  profile.process_data(data);
                }
                return response;
              });
          }
        },
        save_image: function (file) {
          if (file) {
            let promise = false;
            Upload.base64DataUrl(file).then(function (url) {
              promise = $http.put(window.location.api('users/' + currentUser.data.iuserid + '/profile/image'), {
                image: url
              })
                .then(function (response) {
                  if (response.data.url) {
                    profile.data.profile_image = response.data.url;
                  }
                });
            });
            return promise;
          }
          return false;
        },
        games_watched_count: function () {
          if (profile.data) {
            return profile.data.live_watched_count + profile.data.archived_watched_count;
          } else {
            return 0;
          }
        }
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/myProfile/myProfileService.js